import { BookingConfirmation } from "@/components";

function BookingConfirmationPage() {
  return <BookingConfirmation />;
}

export { BookingConfirmationPage };
